import React, { useState, useEffect } from "react";
import callPostApi from "requests/PostRequests";
import * as Constants from "../../../requests/URLConstants";
import DashboardTable from "../DashboardTable";
import moment from "moment";
import * as DashboardUtils from "../DashboardUtils.js";
import TableToolbarDownload from "../../../common/TableToolbarDownload";
import DashboardSummary from "../DashboardSummaryNew";
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

const QueueManagement = (props) => {
    const [QueueManagementLoading, setQueueManagementLoading] = useState(true);
    const [QueueManagementTableData, setQueueManagementTableData] = useState([]);
    const [QueueManagementSummaryData, setQueueManagementSummaryData] = useState([]);
    const [QueueManagementTableHeaders, setQueueManagementTableHeaders] = useState([]);

    useEffect(() => {
        getQueueManagement(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getQueueManagementSummary = (param) => {

        let summary = [
            {
                title: DashboardConstants.Completed,
                value: param.completed
            },
            {
                title: DashboardConstants.Pending,
                value: param.pending
            },
            {
                title: DashboardConstants.Running,
                value: param.running
            },
            {
                title: DashboardConstants.Exception,
                value: param.exception
            },
        ];

        if (param.completed === 0 || !param.completed) {
            summary = summary.filter(summary => summary.title !== "Completed");
        }
        if (param.pending === 0 || !param.pending) {
            summary = summary.filter(summary => summary.title !== "Pending");
        }
        if (param.running === 0 || !param.running) {
            summary = summary.filter(summary => summary.title !== "Running");
        }
        if (param.exception === 0 || !param.exception) {
            summary = summary.filter(summary => summary.title !== "Exception");
        }

        setQueueManagementSummaryData(summary);
    };

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;
        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "queueName": dashboardFilterSelectionsAutomation.queue_name,
                    "job_id": dashboardFilterSelectionsAutomation.job_id,
                    "itemStatus_A1": dashboardFilterSelectionsAutomation.itemStatus_A1,
                    "automata_name":dashboardFilterSelectionsAutomation.automata_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                    "process_name": dashboardFilterSelectionsAutomation.process_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    const prepareQueueManagementData = (response) => {
        let tableData = [];
        let tableObj = {};
        let summaryData = { completed: 0, pending: 0, running: 0, exception: 0 };
        let summaryResult = {};
        let headersobj = [];
        let headerResult = [];
        let headers = [
            {
                key: "ProcessName",
                header: DashboardConstants.AutomataName
            },
            {
                key: "QueueName",
                header: DashboardConstants.QueueName
            },
            {
                key: "totalItems",
                header: DashboardConstants.NoOfItems
            },
        ];

        if (response) {
            let buckets = response.aggregations.process.buckets;

            for (let i = 0; i < buckets.length; i++) {
                let queue = buckets[i].queue.buckets

                for (let j = 0; j < queue.length; j++) {
                    let timeobj = queue[j].time;

                    tableObj = {
                        id: buckets[i].key+queue[j].key,
                        ProcessName: buckets[i].key,
                        QueueName: queue[j].key
                    };
                    let sum = 0;
                    for (let k = 0; k < timeobj.buckets.length; k++) {

                        sum = sum + timeobj.buckets[k].doc_count
                        tableObj[timeobj.buckets[k].key] = timeobj.buckets[k].doc_count;
                        console.log(tableObj[timeobj.buckets[k].key]);

                        headersobj.push({key: timeobj.buckets[k].key, header: timeobj.buckets[k].key});
                    }
                    tableObj.totalItems = sum;
                    //console.log(tableObj);
                    tableData.push(tableObj);
                }
                console.log(tableData);
            }
            const map = new Map();
            for (const item of headersobj) {
                //let RequiredHeaders=["Completed","Pending","Running","System Exception","Business Exception","Abandoned","Retried","Running"]
               // let NonRequiredHeaders= ["Internal","Number Verified in CUSI","Added to BP Queue","deleted","1.5 Attachment Picked in Amdocs","no retry","Bussines Exception",""Postponed","Deferred",""];
               //if (!map.has(item.key) && NonRequiredHeaders.indexOf(item.key) === -1) {
                if (!map.has(item.key) && item.key!=='') {
                    map.set(item.key, true);
                    headerResult.push({key: item.key, header: item.header});
                } 
            }
            console.log(headerResult);
            headers = headers.concat(headerResult);
            console.log(headers);
            setQueueManagementTableHeaders(headers);
        }

        tableData.forEach((status) => {
            for (let [key, value] of Object.entries(status)) {
                //let businessexception, systemexception;
                if (summaryResult[key]) {
                    summaryResult[key] += value;
                    // businessexception = summaryResult["Business Exception"] ? summaryResult["Business Exception"] : 0;
                    // systemexception = summaryResult["System Exception"] ? summaryResult["System Exception"] : 0;
                    summaryData = {
                        completed: summaryResult.Completed,
                        pending: summaryResult.Pending,
                        running: summaryResult.Running,
                        exception: summaryResult.Exception
                    };

                } else {
                    summaryResult[key] = value;
                    // businessexception = summaryResult["Business Exception"] ? summaryResult["Business Exception"] : 0;
                    // systemexception = summaryResult["System Exception"] ? summaryResult["System Exception"] : 0;
                    summaryData = {
                        completed: summaryResult.Completed,
                        pending: summaryResult.Pending,
                        running: summaryResult.Running,
                        exception: summaryResult.Exception
                    };
                }
            }
        });
        return { tableData, summaryData };
    };

    const getQueueManagement = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setQueueManagementLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(
                Constants.GETQUEUEMANAGEMENT, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareQueueManagementData(resp);
                    getQueueManagementSummary(formattedData.summaryData);
                    setQueueManagementTableData(formattedData.tableData);
                    setQueueManagementLoading(false);
                })
                .catch((error) => {
                    setQueueManagementLoading(false);
                });
        }
    };

    return (
        <div className="top-margin dashboard">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary
                        loading={QueueManagementLoading}
                        summary={QueueManagementSummaryData}
                        title={DashboardConstants.QueueManagementSummary}
                    />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                        {DashboardConstants.QueueManagement}
                            <div className="download-button">
                                <TableToolbarDownload
                                    iconDescription="Export" rows={QueueManagementTableData} headers={QueueManagementTableHeaders}
                                    title={DashboardConstants.QueueManagement} filename={DashboardConstants.QueueManagement} label={DashboardConstants.Download}
                                />
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={QueueManagementLoading} rows={QueueManagementTableData} headers={QueueManagementTableHeaders} showPagination={true} isSortingAllowed={true}/>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default QueueManagement;
